import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ItfgDataTableColumn } from '@app/core/components/data-table/types/data-table.column';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'itfg-applications-dialog',
    templateUrl: './applications-dialog.component.html',
    styleUrls: ['./applications-dialog.component.scss'],
    standalone: false
})
export class ApplicationsDialogComponent implements OnInit {
  applications: any[] = [];
  displayedColumns: ItfgDataTableColumn[] = [];

  constructor(
    public dialogRef: MatDialogRef<ApplicationsDialogComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { applications: any[] }
  ) {
    this.applications = data.applications || [];
  }

  ngOnInit() {
    this.initializeColumns();
  }

  initializeColumns() {
    this.translateService
      .get([
        'global.id',
        'global.date',
        'global.principal',
        'global.source',
        'global.partner',
        'global.status',
      ])
      .subscribe((translation: string[]) => {
        this.displayedColumns = [
          { name: 'id', label: translation['global.id'] },
          { name: 'createTime', label: translation['global.date'] },
          { name: 'principal', label: translation['global.principal'] },
          { name: 'source', label: translation['global.source'] },
          { name: 'partner', label: translation['global.partner'] },
          { name: 'status', label: translation['global.status'] },
        ];
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
